import { TaskStatusEnum } from '../components/TaskList/TaskList'
import { ConnectedIntegration, FleetApplication, User } from '.'
import { PlaidAccount } from './plaid'
import { Trailer } from './trailer'
import { Truck } from './truck'

export enum OnboardingChecklistName {
  SIGN_AGREEMENT = 'SIGN_AGREEMENT',
  DRIVER_APPLICATION = 'DRIVER_APPLICATION',
  FLEET_APPLICATION = 'FLEET_APPLICATION',
  FLEET_DETAILS = 'FLEET_DETAILS',
  FLEX_AGREEMENT = 'FLEX_AGREEMENT',
  FLEX_STARTER_SUBSCRIPTION = 'FLEX_STARTER_SUBSCRIPTION',
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
  ADD_DRIVERS = 'ADD_DRIVERS',
  ADD_INDIVIDUAL_DRIVER = 'ADD_INDIVIDUAL_DRIVER',
  TAX_INFO = 'TAX_INFO',
  ELD_SETUP = 'ELD_SETUP',
  EQUIPMENT_SETUP = 'EQUIPMENT_SETUP',
  EQUIPMENT_DOCUMENTS = 'EQUIPMENT_DOCUMENTS',
  ADD_INDIVIDUAL_EQUIPMENT = 'ADD_INDIVIDUAL_EQUIPMENT',
  ADD_INDIVIDUAL_EQUIPMENT_DOCUMENTS = 'ADD_INDIVIDUAL_EQUIPMENT_DOCUMENTS',
  BROKER_SETUP = 'BROKER_SETUP',
  ADD_INDIVIDUAL_BROKER = 'ADD_INDIVIDUAL_BROKER',
  PAYMENT_PROFILE_SETUP = 'PAYMENT_PROFILE_SETUP',
  BANK_ACCOUNT_INFO = 'BANK_ACCOUNT_INFO',
  CONFIRM_CT_CARD_INFO = 'CONFIRM_CT_CARD_INFO',
  STRIPE_PAYMENT_PROFILE = 'STRIPE_PAYMENT_PROFILE',
  CREDIT_APPLICATION = 'CREDIT_APPLICATION',
  INSURANCE_INFORMATION = 'INSURANCE_INFORMATION',
  EMPLOYMENT_HISTORY = 'EMPLOYMENT_HISTORY',
  CONTRACTOR_PAYMENTS_PROFILE = 'CONTRACTOR_PAYMENTS_PROFILE',
  PAYROLL_BANK_ACCOUNT = 'PAYROLL_BANK_ACCOUNT',
  ADD_CONTRACTOR = 'ADD_CONTRACTOR',
  CONTRACTOR_PERSONAL_PROFILE = 'CONTRACTOR_PERSONAL_PROFILE',
  CONTRACTOR_PERSONAL_DIRECT_DEPOSIT = 'CONTRACTOR_PERSONAL_DIRECT_DEPOSIT',
  CONTRACTOR_PERSONAL_DEBIT_CARD = 'CONTRACTOR_PERSONAL_DEBIT_CARD',
}

export interface OnboardingChecklist {
  name: OnboardingChecklistName
  context?: {
    user?: User
    provider?: ConnectedIntegration
    truck?: Truck
    trailer?: Trailer
    fleetApplication?: FleetApplication
    integrations?: ConnectedIntegration[]
    plaidAccount?: PlaidAccount
  }
  status: TaskStatusEnum
  statusDetail?:
    | 'IN_REVIEW'
    | 'MISSING_INFORMATION'
    | 'MISSING_HIRERIGHT_INFORMATION'
    | 'NOT_SUBMITTED'
    | 'CONTACT_CLOUDTRUCKS_REPRESENTATIVE'
    | 'COMPLETE_PREVIOUS_TASKS'
    | 'NOT_CASH_USER'
    | 'FLEET_NOT_ELIGIBLE'
  subitems: ReadonlyArray<OnboardingSubChecklist>
}

export type OnboardingSubChecklist = Omit<OnboardingChecklist, 'subitems'>
